interface IIcon {
  width?: string;
  color?: string;
  height?: string;
}
const CrossCircleFileIcon = ({ width = '16', color = '#AAAAAA', height = '16' }: IIcon) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_528_8805)">
      <path
        d="M13.2754 4.0625C13.0165 4.0625 12.8066 3.85262 12.8066 3.59375V0H6.08789C5.31248 0 4.68164 0.630844 4.68164 1.40625V6.64653C4.83608 6.63253 4.99236 6.625 5.15039 6.625C6.74814 6.625 8.17842 7.3555 9.12495 8.5H14.2129C14.4718 8.5 14.6816 8.70988 14.6816 8.96875C14.6816 9.22762 14.4718 9.4375 14.2129 9.4375H9.74252C10.0355 10.0092 10.2245 10.6427 10.2851 11.3125H14.2129C14.4718 11.3125 14.6816 11.5224 14.6816 11.7812C14.6816 12.0401 14.4718 12.25 14.2129 12.25H10.2851C10.1449 13.7981 9.3178 15.1508 8.11158 16H15.4629C16.2383 16 16.8691 15.3692 16.8691 14.5938V4.0625H13.2754ZM14.2129 6.625H7.33789C7.07902 6.625 6.86914 6.41512 6.86914 6.15625C6.86914 5.89738 7.07902 5.6875 7.33789 5.6875H14.2129C14.4718 5.6875 14.6816 5.89738 14.6816 6.15625C14.6816 6.41512 14.4718 6.625 14.2129 6.625Z"
        fill={color}
        fillOpacity="0.5"
      />
      <path
        d="M13.7441 0.274414V3.12495H16.5945L13.7441 0.274414Z"
        fill={color}
        fillOpacity="0.5"
      />
      <path
        d="M5.15039 7.5625C2.82417 7.5625 0.931641 9.45503 0.931641 11.7812C0.931641 14.1075 2.82417 16 5.15039 16C7.47661 16 9.36914 14.1075 9.36914 11.7812C9.36914 9.45503 7.47661 7.5625 5.15039 7.5625ZM6.88808 12.8561C7.07114 13.0391 7.07114 13.3359 6.88808 13.519C6.79658 13.6105 6.67661 13.6562 6.55664 13.6562C6.43667 13.6562 6.3167 13.6105 6.2252 13.5189L5.15039 12.4442L4.07558 13.519C3.98408 13.6105 3.86411 13.6562 3.74414 13.6562C3.62417 13.6562 3.5042 13.6105 3.4127 13.5189C3.22964 13.3359 3.22964 13.0391 3.4127 12.856L4.48748 11.7812L3.41267 10.7064C3.22961 10.5234 3.22961 10.2266 3.41267 10.0435C3.5957 9.8605 3.89252 9.8605 4.07558 10.0435L5.15039 11.1183L6.2252 10.0435C6.40823 9.8605 6.70505 9.8605 6.88811 10.0435C7.07117 10.2266 7.07117 10.5234 6.88811 10.7064L5.8133 11.7812L6.88808 12.8561Z"
        fill={color}
        fillOpacity="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_528_8805">
        <rect width="16" height="16" fill="white" transform="translate(0.400391)" />
      </clipPath>
    </defs>
  </svg>
);

export default CrossCircleFileIcon;
